export const testimoData = [
    {
      id: 1,
      src: "https://s3.amazonaws.com/img.mynetdiary.com/images/cover-insights-Illustration-1@2x.png",
      title: "Find your Diet",
      desc: "Find a diet that fits your lifestyle: Calorie Counting, Low-Carb, Keto, Vegan, Vegetarian and more.",
      link: ".",
    },
    {
      id: 2,
      src: "https://s3.amazonaws.com/img.mynetdiary.com/images/cover-insights-Illustration-2@2x.png",
      title: "Set Your Targets",
      desc: "Choose your desired weekly weight loss rate, target date, and source of calories like fat, carbs, and proteins.",
      link: ".",
    },
    {
      id: 3,
      src: "https://s3.amazonaws.com/img.mynetdiary.com/images/cover-insights-Illustration-4@2x.png",
      title: "Log Your Meals and Exercise",
      desc: "Use the App to track your food, physical activities, and nutrients. Use the barcode scanner. Log ahead of time for better planning and scheduling.",
      link: ".",
    },
    {
      id: 4,
      src: "https://s3.amazonaws.com/img.mynetdiary.com/images/cover-insights-Illustration-3@2x.png",
      title: "Reach Your Goals",
      desc: "Monitor your daily progress, check your weight loss forecast, and receive ongoing advice and feedback. Learn more about nutrients in your diet and make better choices.",
      link: ".",
    },
  ];